// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2p-cascade{width:100%}.d2p-cascade .el-cascader__tags .el-tag>span{-webkit-box-flex:1;-ms-flex:auto;flex:auto}", ""]);
// Exports
module.exports = exports;
